
import { Options, Vue } from 'vue-class-component'
import { useI18n } from 'vue-i18n'

@Options({})
export default class SecurityAlertView extends Vue {
    iN = useI18n().t
    accounts = [{ id: '6000' }, { id: '6001' }]
    closeCountdown = 5
    closeTimer: ReturnType<typeof setInterval> | null = null

    mounted(): void {
        this.closeTimer = setInterval(() => {
            if (this.closeCountdown <= 1) {
                this.closeCountdown = 0
                this.clearCloseTimer()
                return
            }
            this.closeCountdown -= 1
        }, 1000)
    }

    beforeUnmount(): void {
        this.clearCloseTimer()
    }

    get closeLabel(): string {
        if (this.closeCountdown > 0) {
            return this.iN('securitynotice.closeCountdown', {
                n: this.closeCountdown
            })
        }
        return this.iN('securitynotice.close')
    }

    clearCloseTimer(): void {
        if (this.closeTimer) {
            clearInterval(this.closeTimer)
            this.closeTimer = null
        }
    }

    onClose(): void {
        if (this.closeCountdown > 0) return
        this.$emit('close')
    }
}
